import { useState, memo, useReducer } from "react";
import { addDoc, serverTimestamp } from "firebase/firestore";
import { useFirebaseConnectionContext, useFirebaseWishesDataFetch } from "../../contexts/FirebaseConnectionContext";
import { useModalContext } from "../../contexts/ModalContext";
import gift from "../../assets//images/gift.jpg";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  number: yup.number().min(0),
  text: yup
    .string()
    .min(5, "Le nom du souhait doit contenir au moins 5 caractères")
    .max(15, "Le nom ne peut pas dépasser 15 caractères"),
});

const reducer = (state, action) => ({ ...state, ...action });

const AddWishModal = () => {

  const { currentUser } = useFirebaseConnectionContext();
  const { wishesRef } = useFirebaseWishesDataFetch();
  const { closeModal } = useModalContext()

  const [addWishState, addWishDispatch] = useReducer(reducer, {
    id: "",
    name: "",
    status: "Statut",
    description: "",
    price: "",
    url: "",
  });

  const [fetchLoadingCss, setFetchLoadingCss] = useState("hidden");

  const mainDivCss = `text-darkRed sm:w-[60%] relative m-auto global-px bg-ivory rounded-md flex-col py-4 shadow-md w-full`

  const {
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // console.log(errors);

  // useEffect(() => {
  //   const urlRegex = new RegExp(/^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/gm)
  //   const callFetchData = async (url = null) => {
  //     if (url) {
  //       if (!url.match(urlRegex)) {
  //         addWishDispatch({
  //           name: "Veuillez entrer une URL correcte",
  //           price: "",
  //         })
  //       } else {
  //         return fetch(`/.netlify/functions/node-fetch?url=${url}`, {
  //           headers: { accept: "Accept: application/json" },
  //         })
  //           .then((x) => x.json())
  //           .then(({ data, error }) => {
  //             setFetchLoadingCss("hidden")
  //             if (error === "La demande ne peut aboutir") {
  //               addWishDispatch({
  //                 name: "URL incorrecte",
  //                 price: "",
  //               })
  //             } else if (data.result.title && data.result.price) {
  //               addWishDispatch({
  //                 name: data.result.title,
  //                 price: data.result.price,
  //               })
  //             } else {
  //               addWishDispatch({
  //                 name: "Échec de la récupération des données depuis l'URL fournie",
  //                 price: "",
  //               })
  //             }
  //           })
  //       }
  //     }
  //     return null
  //   }

  //   if (addWishState.url !== "") {
  //     setFetchLoadingCss("block")
  //     callFetchData(addWishState.url)
  //   }
  // }, [addWishState.url])

  //Fonction Gestion de l'ajout de wish
  const handleAddWish = async (formDatas) => {
    await addDoc(wishesRef, {
      date: serverTimestamp(),
      description: formDatas.description,
      granted: false,
      image: gift,
      price: formDatas.price,
      providerId: "",
      title: formDatas.name,
      url: formDatas.url,
      userId: currentUser.user.uid,
    });

    addWishDispatch({
      name: "",
      price: "",
      url: "",
      description: "",
    });
    closeModal()
  };

  //Modification du reducer lors des changements dans les inputs
  const handleChange = (e) => {
    const formValue = e.target.id;
    const newReducer = { ...addWishState };
    switch (formValue) {
      case "nameInput":
        newReducer.name = e.target.value;
        break;
      case "priceInput":
        newReducer.price = e.target.value;
        break;
      case "urlInput":
        newReducer.url = e.target.value;
        break;
      case "descriptionInput":
        newReducer.description = e.target.value;
        break;
      default:
        break;
    }
    addWishDispatch(newReducer);
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    handleAddWish(addWishState);
  };

  return (
    // <div className="m-0 p-2 flex items-center fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-[100%] w-[100%]`">
    // <div className={mainDivCss} onClick={e => e.stopPropagation()}>
    //   <header className="flex w-full text-darkOrange bg-darkRed rounded-md global-px py-4 shadow-inner shadow-darkOrange">
    //     <h2 className=" font-bold text-[1.2em] w-full">Nouveau souhait</h2>
    //     <i
    //       className="max-h-6 hover:scale-105 cursor-pointer transition-transform px-[2rem] absolute right-6 top-5"
    //       onClick={closeModal}
    //     >
    //       {cross}
    //     </i>
    //   </header>
    <div className="h-3/4">
      <form
        onSubmit={handleOnSubmit}
        className="h-full pt-[2em] justify-center items-center flex flex-col"
      >
        {/* <input
                id="urlInput"
                onChange={handleChange}
                value={addWishState.url || ""}
                className="placeholder:text-darkYellow border-darkYellow mb-[1em] w-2/3  border-2 rounded-[0.25em]"
                type="url"
                placeholder="Lien Internet"
              /> */}
        <input
          id="nameInput"
          value={addWishState.name || ""} //Gestion controlled/uncontrolled
          onChange={handleChange}
          className="placeholder:text-darkYellow border-darkYellow border-2 rounded-[0.25em] w-2/3"
          type="text"
          required
          placeholder="Nom du souhait"
        />
        {/* <div className="pt-[1em] ">
                <select
                  onChange={handleStatusChange}
                  value={addWishState.status || ""}
                  className="border-darkYellow w-2/3 border-2 rounded-[0.25em]"
                >
                  <option value={addWishState.status} disabled selected>Statut</option>
                  <option>Libre</option>
                  <option>Réservé</option>
                  <option>Acheté</option>
                </select>
              </div> */}
        <input
          id="priceInput"
          onChange={handleChange}
          value={addWishState.price || ""}
          className="placeholder:text-darkYellow mt-[1em] w-2/3 border-darkYellow border-2 rounded-[0.25em]"
          type="number"
          placeholder="Prix"
        />
        <input
          id="urlInput"
          onChange={handleChange}
          value={addWishState.url || ""}
          className="placeholder:text-darkYellow border-darkYellow mt-[1em] w-2/3  border-2 rounded-[0.25em]"
          type="url"
          placeholder="Lien Internet"
        />
        <textarea
          id="descriptionInput"
          value={addWishState.description || ""}
          className="focus:outline-none placeholder:text-darkYellow border-darkYellow mt-[1em] w-2/3 border-2 rounded-[0.25em]"
          placeholder="Commentaire"
          onChange={handleChange}
        ></textarea>
        <div className="pt-6">
          <span className={fetchLoadingCss}>Chargement...</span>
        </div>
        <div>
          <button
            type="submit"
            className="gradient mt-[2em] text-[1em] p-[.5em] border-2 rounded-[0.25em] m-auto text-ivory"
          >
            Ajouter mon souhait
          </button>
        </div>
      </form>
    </div>
    // </div>
    // </div>
    // <div
    //   id="overlay"
    //   className={`fixed m-0 z-2 top-0 left-0 w-screen h-screen opacity-50 bg-slate-500`}
    // ></div>
  );
};

export default memo(AddWishModal);
